"use client";

import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  endStock: {},
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setEndInventory(state, action) {
      const productName = action.payload.name;
      const newValue = action.payload.value; // assuming you have a value to set

      if (!state.endStock) {
        state.endStock = {}; // initialize if undefined
      }

      state.endStock[productName] = newValue;
    },

    resetEndStockState(state, action) {
      return initialState;
    },
  },
});

export const { setEndInventory, resetEndStockState } = inventorySlice.actions;

export default inventorySlice.reducer;
